


export default {
    data(){
        return {image: null, modelImage: null}
    },
    mounted() {
        if(!this.accountSettings){
            this.$store.dispatch('fetchImageById', this.content.image_id).then(response => {
                this.image = response;
            });
        }
    },
    computed: {
        showImage() 
        { 
            return this.image != null;
        }
    },
    watch: {
        modelImage: function (newImage, oldImage) {
            if(!newImage) return;
            if(newImage == oldImage) return;
            this.updateImage(newImage);
        }
      },
    methods: {
        updateImage(image){
            let payload = {content: this.content, image: image };
            this.uploadContentImage(payload).then(response => {
                this.$store.dispatch('fetchImageById', response.id).then(response => { 
                    this.image = response;
                });
            }); 
        },
        removeImage(){
            let content = this.content;
            content.image_id = null;
            this.updateContent(content);

            this.image = null;
        }
    }
}